import street11Guide1 from '@/assets/images/11stGuide1.png';
import street11Guide2 from '@/assets/images/11stGuide2.png';
import street11Guide3 from '@/assets/images/11stGuide3.png';
import { Card } from '@/components/atoms/Card';
import useCopy from '@/hooks/useCopy';

const Street11GuideImgCard = () => {
  const { copyToClipboard } = useCopy({
    toastMessage: 'IP가 복사됐어요',
  });
  return (
    <Card className="space-y-[30px] p-[30px]">
      {GuideItems.map((item) => (
        <div className="space-y-5">
          <div className="space-y-2">
            <div className="flex items-center justify-between gap-1.5">
              <div className="flex gap-1.5">
                <Badge label={item.number} />
                <div className="mt-px ">{item.title}</div>
              </div>
              {item.hasButton && (
                <button
                  className="flex h-[34px] items-center gap-1.5 rounded-[8px] bg-gr-200 px-2.5 py-1.5 text-gr-700 Body5M14"
                  onClick={() => {
                    const id =
                      '3.34.167.151;43.200.9.207;13.124.61.168;1.227.58.121;172.28.163.92;172.28.163.91;';
                    copyToClipboard(id);
                  }}
                >
                  IP 복사{' '}
                  <svg
                    width="16"
                    height="16"
                    viewBox="0 0 16 16"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M12 14H8C7.46957 14 6.96086 13.7893 6.58579 13.4142C6.21071 13.0391 6 12.5304 6 12V8C6 7.46957 6.21071 6.96086 6.58579 6.58579C6.96086 6.21071 7.46957 6 8 6H12C12.5304 6 13.0391 6.21071 13.4142 6.58579C13.7893 6.96086 14 7.46957 14 8V12C14 12.5304 13.7893 13.0391 13.4142 13.4142C13.0391 13.7893 12.5304 14 12 14ZM8 7.33333C7.82319 7.33333 7.65362 7.40357 7.5286 7.5286C7.40357 7.65362 7.33333 7.82319 7.33333 8V12C7.33333 12.1768 7.40357 12.3464 7.5286 12.4714C7.65362 12.5964 7.82319 12.6667 8 12.6667H12C12.1768 12.6667 12.3464 12.5964 12.4714 12.4714C12.5964 12.3464 12.6667 12.1768 12.6667 12V8C12.6667 7.82319 12.5964 7.65362 12.4714 7.5286C12.3464 7.40357 12.1768 7.33333 12 7.33333H8Z"
                      fill="#53555E"
                    />
                    <path
                      d="M6.48667 10H3.78C3.30846 9.99824 2.85672 9.81014 2.52329 9.47671C2.18986 9.14328 2.00176 8.69155 2 8.22V3.78C2.00176 3.30846 2.18986 2.85672 2.52329 2.52329C2.85672 2.18986 3.30846 2.00176 3.78 2H8.22C8.69155 2.00176 9.14328 2.18986 9.47671 2.52329C9.81014 2.85672 9.99824 3.30846 10 3.78V6.26667H8.66667V3.78C8.66667 3.66154 8.61961 3.54793 8.53584 3.46416C8.45208 3.38039 8.33846 3.33333 8.22 3.33333H3.78C3.66154 3.33333 3.54793 3.38039 3.46416 3.46416C3.38039 3.54793 3.33333 3.66154 3.33333 3.78V8.22C3.33333 8.33846 3.38039 8.45208 3.46416 8.53584C3.54793 8.61961 3.66154 8.66667 3.78 8.66667H6.48667V10Z"
                      fill="#53555E"
                    />
                  </svg>
                </button>
              )}
            </div>
            {item.desc && <div className="pl-7 Body5M14">{item.desc}</div>}
          </div>
          {item.image && (
            <div className="flex justify-center px-[30px]">
              <img src={item.image} className="w-full" />
            </div>
          )}
        </div>
      ))}
    </Card>
  );
};

export default Street11GuideImgCard;

const Badge = ({ label }: { label: number }) => {
  return (
    <span className=" Caption2B12 flex h-[22px] w-[22px]  items-center justify-center rounded-[4px] bg-blue-400 text-white">
      {label}
    </span>
  );
};

const GuideItems = [
  { number: 1, title: <span>11번가 API 사이트 접속</span> },
  {
    number: 2,
    title: (
      <>
        <span className="font-bold">API 관리</span> 클릭
      </>
    ),
    image: street11Guide1,
  },
  {
    number: 3,
    title: (
      <>
        <span className="font-bold">API KEY</span> 관리에서 인증 후 키를 생성
      </>
    ),
    desc: (
      <>
        API KEY를 셀러박스 화면 상단에 OPEN API KEY에 입력하고 아래 단계를 마저 진행해 주세요. 이미
        API KEY를 발급 받으셨으면 해당 API키를 복사해 주세요.
      </>
    ),
    image: street11Guide2,
  },
  {
    number: 4,
    title: (
      <div className="flex items-start gap-1.5">
        <div>
          <span className="font-bold">IP 직접입력 사용</span> 선택 후{' '}
          <span className="font-bold">IP를</span> 모두 입력 후 수정하기 클릭
        </div>
      </div>
    ),
    image: street11Guide3,
    hasButton: true,
    desc: (
      <>
        개발서버 IP, 개발자 PC, 상용서버 IP
        에3.34.167.151;43.200.9.207;13.124.61.168;1.227.58.121;172.28.163.92;172.28.163.91; 를
        입력해 주세요.
      </>
    ),
  },
];
